export default __webpack_public_path__ + "media/express.9ca72e66.png";